import React from "react";
import { useTranslation } from "react-i18next";

/** A2-537 / A2-581 lead 16 — on a calc locked for filing, Steps 1-3 stay
 *  usable (files, period, rates, Run) because they start a SEPARATE
 *  calculation; the filed one changes only by superseding it on Step 6.
 *  Only Step 1 said so; Steps 2 and 3 looked like they edited the filing. */
export const LockedCalcNote = ({ calc, step }) => {
  const { t } = useTranslation();
  if (!calc?.frozen) return null;
  const ref = calc.filing_reference || "—";
  const text = step === 1
    ? t("ui.step1.locked_note", { ref,
        defaultValue: `This calculation is locked for filing (${ref}). Uploading or running here starts a separate calculation and does not change what was filed. To correct the filed return, use “Supersede this filing” on Step 6.` })
    : t("ui.step1.locked_note_inputs", { ref,
        defaultValue: `This calculation is locked for filing (${ref}). Changing the files, period or rates here, or running, starts a separate calculation and does not change what was filed. To correct the filed return, use “Supersede this filing” on Step 6.` });
  return (
    <p data-testid={`step-${step}-locked-note`} role="status"
      className="rounded-lg border border-amber-300 dark:border-amber-700 bg-amber-50 dark:bg-amber-950/40 px-3 py-2 text-sm text-amber-900 dark:text-amber-100">
      {text}
    </p>
  );
};

// A2-581 lead 30: the out-of-date state showed only from Step 3 (the
// identity header), so changing files, period, client or rates on Steps
// 1-2 gave no sign the last calculation no longer matched.
export const StaleInputsNote = ({ calc, derived, step }) => {
  const { t } = useTranslation();
  if (!calc || calc.frozen || !derived?.calcStale) return null;
  return (
    <p data-testid={`step-${step}-stale-note`} role="status"
      className="rounded-lg border border-amber-300 dark:border-amber-700 bg-amber-50 dark:bg-amber-950/40 px-3 py-2 text-sm text-amber-900 dark:text-amber-100">
      {t("ui.step1.stale_note", { defaultValue: "These inputs no longer match the last calculation. Run it again before reviewing or signing off." })}
      {(derived.staleReasons || []).length > 0 && <> ({derived.staleReasons.join("; ")})</>}
    </p>
  );
};

export default LockedCalcNote;
